const SUBSCRIPTIONS_KEY = '__subscriptions__' as const;

export default SUBSCRIPTIONS_KEY;
